import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  badge?: string;
  badgeColor?: string;
  gradient: string;
  accentColor: string;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ icon, title, subtitle, badge, badgeColor, gradient, accentColor, actions }) => (
  <div className="page-header" style={{ background: gradient }}>
    <div className="page-header-pattern" />
    <div className="page-header-content">
      <div className="page-header-left">
        <div className="page-header-icon" style={{ background: `rgba(255,255,255,0.2)`, boxShadow: `0 4px 16px rgba(0,0,0,0.15)` }}>
          {icon}
        </div>
        <div className="page-header-text">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </div>
      <div className="page-header-right">
        {badge && (
          <span className="page-header-badge" style={{ background: badgeColor || 'rgba(255,255,255,0.2)', color: '#fff' }}>
            {badge}
          </span>
        )}
        {actions}
      </div>
    </div>
  </div>
);

export default PageHeader;
